import type { GrayscalePalette } from './types';

export const skinTonesPalette: GrayscalePalette = {
  id: 'skin-tones',
  name: 'Skin Tones',
  type: 'grayscale',
  characters: ['\u{1F3FF}', '\u{1F3FE}', '\u{1F3FD}', '\u{1F3FC}', '\u{1F3FB}'],
};
